import confetti from "./bo/confetti.png";
import dj from "./bo/dj.png";
import empty from "./bo/empty.png";
import polish from "./bo/polish.png";
import scissors from "./bo/scissors.png";
import search from "./bo/search.png";
import shrug from "./bo/shrug.png";
import stone from "./bo/stone.png";
import thumbs from "./bo/thumbs.png";
import wave from "./bo/wave.png";
import logo from "./brand/logo.png";

const sageIllustrations: Record<string, string> = {
  confetti,
  dj,
  empty,
  polish,
  scissors,
  search,
  shrug,
  stone,
  thumbs,
  wave,
};

export { logo, sageIllustrations };
